/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Warm_Owl_GearInputs */

const en_soft_warm_owl_gear = /** @type {(inputs: Soft_Warm_Owl_GearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration`)
};

const de_soft_warm_owl_gear = /** @type {(inputs: Soft_Warm_Owl_GearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfiguration`)
};

/**
* | output |
* | --- |
* | "Configuration" |
*
* @param {Soft_Warm_Owl_GearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_warm_owl_gear = /** @type {((inputs?: Soft_Warm_Owl_GearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Warm_Owl_GearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_warm_owl_gear(inputs)
	return de_soft_warm_owl_gear(inputs)
});